const config = require('@/config/config.json')
const consts = require('@/config/consts.json')

export default {
  data () {
    return {
      config: config,
      consts: consts
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/config.js